import SellerTranscript from './SellerTranscript.component';

export default SellerTranscript;
